import { Alert, AlertDescription, AlertIcon } from 'components/v4';

function AlertComponent({ status, description }) {
    return (
        <Alert status={status} mt={4}>
            <AlertIcon />
            <AlertDescription>{description}</AlertDescription>
        </Alert>
    );
}

export default AlertComponent;
